import {
    BoxAccess,
    classNames, layout, PushButton,
    theme, usePlatform, useStorageItemValue,
    View,
    ViewContent, ViewHeader, ViewHeaderItem
} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {Tenant} from "../types";
import {useLocalization} from "../../i18n";
import {useCallback, useState} from "react";
import {Box} from "@variocube/app-api";

export interface ItemTabProps {
}

export function OverviewTab({}: ItemTabProps) {
    const platform = usePlatform();
    const {t} = useLocalization();

    const tenant = useStorageItemValue<Tenant>("tenant");
    const plasticBagBoxes = useStorageItemValue<string[]>("plasticBagBoxes");
    const plasticBagBoxes2Rolls = useStorageItemValue<string[]>("plasticBagBoxes2Rolls");
    const bigBagBoxes = useStorageItemValue<string[]>("bigBagBoxes");
    const wasteBoxes = useStorageItemValue<string[]>("wasteBoxes");

    const [textPrefix, setTextPrefix] = useState<string>("Waste");

    const [boxes, setBoxes] = useState<Box[] | undefined>();

    const handleOpenAll = useCallback( (boxNumbers: string[]) => {
        setBoxes(platform.boxes.filter((b => boxNumbers.indexOf(b.number) != -1)));
    }, []);

    const handlePlasticBags = useCallback(() => {
        if(plasticBagBoxes) {
            setTextPrefix("PlasticBags");
            handleOpenAll(plasticBagBoxes);
        }
    }, [plasticBagBoxes]);
    const handlePlasticBags2Rolls = useCallback(() => {
        if(plasticBagBoxes2Rolls) {
            setTextPrefix("PlasticBags");
            handleOpenAll(plasticBagBoxes2Rolls);
        }
    }, [plasticBagBoxes2Rolls]);
    const handleBigBags = useCallback(() => {
        if(bigBagBoxes) {
            setTextPrefix("BigBags");
            handleOpenAll(bigBagBoxes);
        }
    }, [bigBagBoxes]);
    const handleWaste = useCallback(() => {
        if(wasteBoxes) {
            setTextPrefix("Waste");
            handleOpenAll(wasteBoxes);
        }
    }, [wasteBoxes]);

    const handleConfirm = useCallback(() => {
        setBoxes(undefined);
    }, []);

    if(boxes) {
        return (<BoxAccess boxes={boxes} platform={platform}
                           onConfirm={handleConfirm}
                           onCancel={() => setBoxes(undefined)}
                           boxOpenTitle={t("Admin" + textPrefix + "OpenTitle" as any)}
                           boxOpenMessage={t("Admin" + textPrefix + "OpenMessage" as any)}
                           confirmTitle={t("Admin" + textPrefix + "ConfirmTitle" as any)}
                           confirmMessage={t("Admin" + textPrefix + "ConfirmMessage" as any)}
                           strings={t} />);
    }

    return (
        <View>
            <ViewHeader className={theme.lessContrast}>
                <ViewHeaderItem fill className={classNames(layout.paddingMedium, styles.branding)}>
                    {t("Admin")}: {tenant ? tenant.user : "..."}
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={classNames(layout.vertical, layout.paddingMedium, layout.alignCenter, layout.spaceEvenly)}>
                <div className={(classNames(layout.horizontal))}>
                    <div className={classNames(theme.moreContrast, layout.vertical, layout.spaceBetween, styles.boxSizeLeft)}>
                        <div className={classNames(styles.boxTitle)}>
                            <div>{t("AdminBags")}</div>
                        </div>
                        <div className={classNames(styles.boxInfo)}>
                            {t("AdminBagsInfo")}
                        </div>
                        <div className={classNames(layout.horizontal, layout.spaceEvenly)}>
                            <PushButton onClick={handlePlasticBags}>{t("PlasticBags1RollButton")}</PushButton>
                            <PushButton onClick={handlePlasticBags2Rolls}>{t("PlasticBags2RollButton")}</PushButton>
                        </div>
                        <div style={{paddingTop: "1rem"}}>
                            <PushButton className={styles.fullWidth} onClick={handleBigBags}>{t("BigBagsButton")}</PushButton>
                        </div>
                    </div>
                    <div className={classNames(theme.lessContrast, layout.vertical, layout.spaceBetween, styles.boxSizeRight)}>
                        <div className={classNames(styles.boxTitle)}>
                            <div>{t("AdminWaste")}</div>
                        </div>
                        <div className={classNames(styles.boxInfo)}>
                            {t("AdminWasteInfo")}
                        </div>
                        <div className={classNames(layout.horizontal, layout.spaceEvenly)}>
                            <PushButton onClick={handleWaste}>{t("WasteButton")}</PushButton>
                        </div>
                    </div>
                </div>
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    branding: {
        fontSize: "2em",
        fontWeight: 300,
        color: "var(--color-primary)"
    },
    boxSizeLeft: {
        width: "24em",
        height: "16em",
        padding: "1.5em"
    },
    boxSizeRight: {
        width: "16em",
        height: "16em",
        padding: "1.5em"
    },
    boxTitle: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "1.25em"
    },
    boxInfo: {
        textAlign: "justify",
        height: "7em"
    },
    fullWidth: {
        width: "100%"
    }
});